const getters = {
    GET_TELCOS: (state) => state.telcos,
    GET_DATA_CATEGORIES: (state) => state.data_categories,
    GET_DATA_SERVICES: (state) => state.data_services,
}

export default getters
